import { createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {};

export const getCurrentLocation = createAsyncThunk(
  'location/getCurrentLocation',
  async (_, thunkAPI) => {
    // minimal placeholder: return empty object
    return {};
  }
);

export const resetLocation = () => ({ type: 'location/reset' });

export default function locationSlice(state = initialState, action) {
  switch (action.type) {
    case 'location/reset':
      return initialState;
    default:
      return state;
  }
}
